import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";

export default function BookingCancel() {
  return (
    <div style={{ background: "var(--cream)", minHeight: "100vh" }}>
      <Navbar />
      <main className="pt-40 pb-32 px-6 md:px-12 lg:px-20">
        <div className="max-w-[820px] mx-auto">
          <div className="mono-eyebrow">§ Payment cancelled</div>
          <h1 className="serif text-5xl md:text-7xl mt-6 leading-[0.98]" style={{ letterSpacing: "-0.03em" }}>
            No harm done.
          </h1>
          <p className="mt-6 text-lg max-w-[520px]" style={{ color: "var(--ink-2)" }}>
            Your booking wasn't completed. Come back whenever you're ready — the chair is still here.
          </p>
          <div className="mt-10 flex gap-4">
            <Link to="/book" className="btn-terra" data-testid="try-again-btn">Try again</Link>
            <Link to="/" className="btn-ghost">Back home</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
